<template>
  <ontos-named-list-input ref="identity"
                          :name="value.name" :alias="value.alias"
                          :name-label="$tt('domain-name')"
                          :fixed-alias="fixedAlias" :start-with-auto-alias="startWithAutoAlias"
                          :siblings="domains"
                          @update:name="patch('name', $event)"
                          @update:alias="patch('alias', $event)">
    <!-- A ordem das opções é dado (a listagem ordena por ela): por isso o arrasto -->
    <ontos-colored-entry-list ref="options" editable reorderable :min="1"
                              :entries="value.options" :title="$tt('options')" :level="3" dense
                              :create-label="$tt('option-create')"
                              @update:entries="patch('options', $event)"/>
  </ontos-named-list-input>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import NamedListInput from '@/components/shared/NamedListInput.vue'
import ColoredEntryList from '@/components/shared/ColoredEntryList.vue'
import Domain from '@/types/Domain'

/**
 * O editor de um domínio: nome, alias e a lista de opções, cada uma com cor e alias — a identidade
 * pelo NamedListInput, como o fluxo, e as opções pela lista comum (`ColoredEntryList`), a mesma que
 * o formulário do atributo de seleção usa.
 *
 * Continua existindo como componente para os hosts não mudarem: a página de criar, a de
 * editar e o modal conhecem este nome e chamam `validateModel()` pelo `$refs`.
 */
@Component({
  emits: ['input'],
  name: 'ontos-domain-input',
  components: {
    'ontos-named-list-input': NamedListInput,
    'ontos-colored-entry-list': ColoredEntryList
  }
})
class DomainInput extends Vue {
  @Prop({type: Object, required: true}) readonly value!: Domain
  @Prop({type: Boolean, default: false}) readonly fixedAlias!: boolean
  @Prop({type: Boolean, default: false}) readonly startWithAutoAlias!: boolean
  /** Os irmãos, para a unicidade de nome e alias do próprio domínio. */
  @Prop({type: Array, default: () => []}) readonly domains!: Domain[]

  /** Saída única: o domínio inteiro com o campo alterado. */
  patch(field: 'name' | 'alias' | 'options', value: any) {
    this.$emit('input', {...this.value, [field]: value})
  }

  /** O contrato com os hosts: eles validam por aqui antes de gravar. */
  validateModel(): boolean {
    //As duas metades, sem curto-circuito: os erros de todas aparecem de uma vez
    const options = (this.$refs.options as any).validateModel()
    return (this.$refs.identity as any).validateModel() && options
  }
}

export default toNative(DomainInput)
</script>
